module.exports = __webpack_public_path__ + "media/FaktSoftPro-Normal_fc4e2e.ttf";